module.exports = __webpack_public_path__ + "assets/scriptaculous.edefbe12.svg";